import React from "react";

const VisionMission = () => {
  return (
    <section className="vision-mission-section py-5 p-0">
      <div className="container">
        <div className="text-center mb-5">
          <h6 className="text-warning fw-bold">OUR COMMITMENT</h6>
          <h2 className="fw-bold">Vision & Mission</h2>
          <p className="text-muted">
            Delivering comfortable, safe, and memorable travel experiences
            across India.
          </p>
        </div>

        <div className="row g-4 p-0">
          {/* Vision */}
          <div className="col-lg-6">
            <div className="card border-0 shadow h-100">
              <div
                className="card-body p-5"
                style={{
                  borderTop: "5px solid #F4B400",
                }}
              >
                <div className="mb-3">
                  <i
                    className="fas fa-eye"
                    style={{
                      fontSize: "50px",
                      color: "#F4B400",
                    }}
                  ></i>
                </div>

                <h3 className="fw-bold mb-3">Our Vision</h3>

                <p className="text-muted">
                  To become India's most trusted travel partner by providing
                  reliable, affordable, and premium transportation solutions.
                  We aim to connect people, destinations, and experiences
                  through safe journeys and exceptional customer service.
                </p>
              </div>
            </div>
          </div>

          {/* Mission */}
          <div className="col-lg-6">
            <div className="card border-0 shadow h-100">
              <div
                className="card-body p-5"
                style={{
                  borderTop: "5px solid #8B1E1E",
                }}
              >
                <div className="mb-3">
                  <i
                    className="fas fa-bullseye"
                    style={{
                      fontSize: "50px",
                      color: "#8B1E1E",
                    }}
                  ></i>
                </div>

                <h3 className="fw-bold mb-3">Our Mission</h3>

                <p className="text-muted">
                  To provide comfortable, punctual, and secure travel services
                  through our fleet of Tempo Travellers, Urbania, Mini Buses,
                  and Coaches. We are committed to customer satisfaction,
                  professional drivers, transparent pricing, and unforgettable
                  travel experiences.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Stats */}
        {/* <div className="row text-center mt-5">
          <div className="col-md-3 col-6 mb-4">
            <h2 className="text-warning fw-bold">1000+</h2>
            <p>Happy Customers</p>
          </div>

          <div className="col-md-3 col-6 mb-4">
            <h2 style={{ color: "#8B1E1E" }} className="fw-bold">
              24/7
            </h2>
            <p>Customer Support</p>
          </div>

          <div className="col-md-3 col-6 mb-4">
            <h2 className="text-warning fw-bold">50+</h2>
            <p>Destinations Covered</p>
          </div>

          <div className="col-md-3 col-6 mb-4">
            <h2 style={{ color: "#8B1E1E" }} className="fw-bold">
              100%
            </h2>
            <p>Safe Travel</p>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default VisionMission;